import * as React from 'react';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';

const styles = require('./ActivityFeedPersonaControl.scss');
const classNames = require('classnames/bind').bind(styles);

export interface ActivityFeedPersonaControlProp {
    name: string;
    emailAddress: string;
}
export interface ActivityFeedPersonaControlProps {
    personas: ActivityFeedPersonaControlProp[];
}
export default function ActivityFeedPersonaControl(
    props: ActivityFeedPersonaControlProps
): JSX.Element {
    const { personas } = props;
    if (personas.length === 0) {
        return null;
    }
    if (personas.length === 1) {
        return (
            <div className={styles.personaGroup}>
                <PersonaControl
                    name={personas[0].name}
                    emailAddress={personas[0].emailAddress}
                    size={PersonaSize.size32}
                    mailboxType={''}
                />
            </div>
        );
    } else {
        // 2 or more personas -> show only first 2
        return (
            <div className={styles.personaGroup}>
                <PersonaControl
                    name={personas[0].name}
                    emailAddress={personas[0].emailAddress}
                    size={PersonaSize.size24}
                    className={styles.smallPersona}
                />
                <PersonaControl
                    name={personas[1].name}
                    emailAddress={personas[1].emailAddress}
                    size={PersonaSize.size24}
                    className={classNames(styles.smallPersona, styles.bottomPersona)}
                />
            </div>
        );
    }
}
